import React, { useEffect } from 'react';
import { get, isEmpty } from 'lodash';
import {
  Route, Redirect, withRouter
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUser } from 'selectors';
import PropTypes from 'prop-types';
import { urlMap } from 'routes/urlMap';
import FeatureToggle from 'components/common/features/FeatureToggle';
import WonoloSpinnerLoader from 'components/common/loaders/WonoloSpinnerLoader';

const NoEvalRedirect = () => <Redirect to={{ pathname: urlMap.FLAGGED_ROUTE }} />;

// THIS IS AN AUTHROUTE BECAUSE OF LD REQ
// feature route must use LD flags so the user must be authorized by default
const FeatureRoute = ({
  OnTrueComponent,
  OnFalseComponent,
  flag,
  path,
  history,
  ...rest
}) => {
  const user = useSelector(getUser);
  const userFetching = isEmpty(user) || get(user, 'fetching');

  useEffect(() => {
    if (!userFetching && !get(user, 'agreedToTerms')) {
      history.push(urlMap.TERMS_OF_SERVICE);
    }
  }, [path, user]);

  if (userFetching) {
    return <WonoloSpinnerLoader />;
  }

  return (
    <Route
      {...rest}
      path={path}
      render={(props) => (
        <FeatureToggle
          flag={flag}
          OnTrueComponent={() => <OnTrueComponent {...props} />}
          OnFalseComponent={() => <OnFalseComponent {...props} />}
        />
      )}
    />
  );
};

FeatureRoute.propTypes = {
  OnTrueComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]),
  OnFalseComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]),
  flag: PropTypes.string.isRequired,
  user: PropTypes.shape({
    canPostJobs: PropTypes.bool.isRequired
  }).isRequired,
  path: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

FeatureRoute.defaultProps = {
  OnTrueComponent: NoEvalRedirect,
  OnFalseComponent: NoEvalRedirect
};

export default withRouter(FeatureRoute);
